<template>
	<div>
		<div class="box">
			<div class="row">
				<h2 class="match-header">Reference: {{title | capitalize}}</h2>
			</div>
            <div class="configuration-reference">
				<!-- Education -->
				<div class="card-row row" v-if="$route.params.reference == 'education'">
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Country</label>
							<md-input v-model.trim="configurationObj.country" @input="configurationObj.country = sanitizeInput($event)" name="country" placeholder="Country"></md-input>						</md-field>
						<p class="error" v-show="errors.has('country')">{{errors.first('country')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>College</label>
							<md-input v-model.trim="configurationObj.college" @input="configurationObj.college = sanitizeInput($event)" name="college" v-validate="'required'" placeholder="College"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('college')">{{errors.first('college')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>State</label>
							<md-input v-model.trim="configurationObj.state" @input="configurationObj.state = sanitizeInput($event)" name="state" placeholder="State"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('state')">{{errors.first('state')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>City</label>
							<md-input v-model.trim="configurationObj.city" @input="configurationObj.city = sanitizeInput($event)" name="city" placeholder="City"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('city')">{{errors.first('city')}}</p>
					</div>
				</div>

				<!-- Location -->
				<div class="card-row row" v-if="$route.params.reference == 'location'">
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Country</label>
							<md-input v-model.trim="configurationObj.country" @input="configurationObj.country = sanitizeInput($event)" name="country" v-validate="'required'" placeholder="Country"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('country')">{{errors.first('country')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>State</label>
							<md-input v-model.trim="configurationObj.state" @input="configurationObj.state = sanitizeInput($event)" name="state" v-validate="'required'" placeholder="State"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('state')">{{errors.first('state')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>City</label>
							<md-input v-model.trim="configurationObj.city" @input="configurationObj.city = sanitizeInput($event)" name="city" v-validate="'required'" placeholder="City"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('city')">{{errors.first('city')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Latitude</label>
							<md-input v-model.trim="configurationObj.latitude" @input="configurationObj.latitude = sanitizeInput($event)" name="latitude" placeholder="Latitude"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('latitude')">{{errors.first('latitude')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Longitude</label>
							<md-input v-model.trim="configurationObj.longitude" @input="configurationObj.longitude = sanitizeInput($event)" name="longitude" placeholder="Longitude"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('longitude')">{{errors.first('longitude')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Population</label>
							<md-input v-model.trim="configurationObj.population" @input="configurationObj.population = sanitizeInput($event)" name="population" placeholder="Population"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('population')">{{errors.first('population')}}</p>
					</div>
				</div>

				<!-- Organization -->
				<div class="card-row row" v-if="$route.params.reference == 'organization'">
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Name</label>
							<md-input v-model.trim="configurationObj.name" @input="configurationObj.name = sanitizeInput($event)" name="name" v-validate="'required'" placeholder="Name"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('name')">{{errors.first('name')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>URL</label>
							<md-input v-model.trim="configurationObj.url" @input="configurationObj.url = sanitizeUrl($event)" name="url" placeholder="URL"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('url')">{{errors.first('url')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Category</label>
							<md-input v-model.trim="configurationObj.category" name="category" placeholder="Category" @input="configurationObj.category = sanitizeInput($event)"></md-input>
						</md-field>
						<!-- <span class="md-helper-text">Multiple category must be comma(,) separated</span> -->
						<p class="error" v-show="errors.has('category')">{{errors.first('category')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Market</label>
							<md-input v-model.trim="configurationObj.market" name="market" placeholder="Market" @input="configurationObj.market = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('market')">{{errors.first('market')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Status</label>
							<md-input v-model.trim="configurationObj.status" name="status" placeholder="Status" @input="configurationObj.status = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('status')">{{errors.first('status')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Country</label>
							<md-input v-model.trim="configurationObj.country" @input="configurationObj.country = sanitizeInput($event)" name="country" placeholder="Country"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('country')">{{errors.first('country')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>State</label>
							<md-input v-model.trim="configurationObj.state" @input="configurationObj.state = sanitizeInput($event)" name="state" placeholder="State"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('state')">{{errors.first('state')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>Region</label>
							<md-input v-model.trim="configurationObj.region" name="region" placeholder="Region" @input="configurationObj.region = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('region')">{{errors.first('region')}}</p>
					</div>
					<div class="col-md-6">
						<md-field class="create-community">
							<label>City</label>
							<md-input v-model.trim="configurationObj.city" @input="configurationObj.city = sanitizeInput($event)" name="city" placeholder="City"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('city')">{{errors.first('city')}}</p>
					</div>
				</div>

				<!-- Role -->
				<div class="card-row row" v-if="$route.params.reference == 'roles'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label>Role</label>
							<md-input v-model.trim="configurationObj.role" name="role" v-validate="'required'" placeholder="Role" @input="configurationObj.role = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('role')">{{errors.first('role')}}</p>
					</div>
					<div class="col-md-12 custom-textarea">
						<md-field class="create-community">
							<label>Description</label>
		                	<md-textarea v-model.trim="configurationObj.description" placeholder="Description" @blur="configurationObj.description = sanitizeInput($event.target.value)"></md-textarea>
		                </md-field>
					</div>
				</div>

				<!--Coaching templates-->
				<div class="card-row row" v-if="$route.params.reference == 'coaching-templates'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label>Title</label>
							<md-input v-model.trim="configurationObj.name" name="name" v-validate="'required'" placeholder="Title" @input="configurationObj.name = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('name')">{{errors.first('name')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label>Content</label>
							<md-textarea
								v-model.trim="configurationObj.content"
								placeholder="Content"
								rows="8"
								style="min-height: 180px;"
								@blur="configurationObj.content = sanitizeInput($event.target.value)">
							</md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('content')">{{errors.first('content')}}</p>
					</div>
				</div>

				<!-- Skills -->
				<div class="card-row row" v-if="$route.params.reference == 'skills'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label>skills</label>
							<md-input v-model.trim="configurationObj.skills" name="skill" v-validate="'required'" placeholder="Skills" @input="configurationObj.skills = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('skill')">{{errors.first('skill')}}</p>
					</div>
				</div>

				<!-- Filter Words -->
				<div class="card-row row" v-if="$route.params.reference == 'filter-words'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label>Word</label>
							<md-input v-model.trim="configurationObj.word" name="word" v-validate="'required'" placeholder="Word" @input="configurationObj.word = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('word')">{{errors.first('word')}}</p>
					</div>
				</div>

				<!-- Interests -->
				<div class="card-row row" v-if="$route.params.reference == 'interests'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label>Interest</label>
							<md-input v-model.trim="configurationObj.interest" @input="configurationObj.interest = sanitizeInput($event)" name="interest" v-validate="'required'" placeholder="Interest"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('interest')">{{errors.first('interest')}}</p>
					</div>
				</div>

				<!-- Protopia OWner -->
				<div class="card-row row" v-if="$route.params.reference == 'protopia-owner'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Owner Name</label>
							<md-input v-model.trim="configurationObj.name" name="ownerName" v-validate="'required'" placeholder="Add Owner Name" @input="configurationObj.name = sanitizeInput($event)"></md-input></md-input>
						</md-field>
						<p class="error" v-show="errors.has('ownerName')">{{errors.first('ownerName')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Owner Email</label>
							<md-input v-model.trim="configurationObj.email" name="ownerEmail" id="ownerEmail" v-validate="'required|email'" placeholder="Add Owner Email" @input="configurationObj.email = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('ownerEmail')">{{errors.first('ownerEmail')}}</p>
					</div>
				</div>
				
				<!-- Protopia OWner -->
				<div class="card-row row" v-if="$route.params.reference == 'wizard-content'">
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Headline</label>
							<md-input v-model.trim="configurationObj.headline" name="headline" :maxlength="80" v-validate.continues="'required|max:80|min:10'" placeholder="Add Headline" @input="configurationObj.headline = sanitizeInput($event)"></md-input>
						</md-field>
						<p class="error" v-show="errors.has('headline')">{{errors.first('headline')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Introduction</label>
							<md-textarea v-model.trim="configurationObj.introduction" :maxlength="250" name="introduction" v-validate.continues="'required|max:250|min:100'" placeholder="Add Introduction" rows="2" @input="configurationObj.introduction = sanitizeInput($event)"></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('introduction')">{{errors.first('introduction')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Content</label>
							<md-textarea v-model.trim="configurationObj.content" :maxlength="2000" name="content" v-validate.continues="'required|max:2000|min:250'" placeholder="Add Content" rows="2" @input="configurationObj.content = sanitizeInput($event)"></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('content')">{{errors.first('content')}}</p>
					</div>
					<div class="col-md-12">
						<md-field class="create-community">
							<label class="card-header">Add Close</label>
							<md-textarea v-model.trim="configurationObj.close" :maxlength="250" name="close" v-validate.continues="'required|max:250|min:5'" placeholder="Add Close" rows="2" @input="configurationObj.close = sanitizeInput($event)"></md-textarea>
						</md-field>
						<p class="error" v-show="errors.has('close')">{{errors.first('close')}}</p>
					</div>
				</div>

				<!-- Common save btn -->
				<div class="row">
					<div class="submitBtn">
						<md-button type="button" @click="updateData()" class="md-raised md-round md-accent">
							Save
						</md-button>
						<md-button type="button" @click="cancel($route.params.reference)" class="md-raised md-round md-accent">Cancel</md-button>
					</div>
				</div>
            </div>
		</div>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput, sanitizeUrl } from '@/utils/sanitizer';
export default {
    data() {
        return {
            fullPage: true,
            api: new API(),
            title: '',
			configurationObj: {}
        }
    },
    watch: {
      $route: "loadData"
    },
    filters: {
        capitalize: function (value) {
			if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    created() {
		const dict = {
			custom: {
				word: {
					required: "Word field is required"
				},
				skill: {
					required: "Skill field is required"
				},
				role: {
					required: "Role field is required"
				},
				name: {
					required: "Name field is required"
				},
				country: {
					required: "Country field is required"
				},
				state: {
					required: "State field is required"
				},
				city: {
					required: "City field is required"
				},
				college: {
					required: "College field is required"
				},
				ownerName: {
					required: () => 'Please enter Protopia Owner Name'
				},
				ownerEmail: {
					required: () => 'Please enter Protopia Owner Email',
                    email: () => 'Please enter valid Email'
				},
				headline: {
					required: () => 'Please enter headline',
					min: () => 'minimum 10 characters',
					max: () => "Headline may not exceed 80 characters"
				},
				introduction: {
					required: () => 'Please enter introduction',
					min: () => 'minimum 100 characters',
					max: () => "Introduction may not exceed 250 characters"
				},
				content: {
					required: () => 'Please enter content',
					min: () => 'minimum 250 characters',
					max: () => "Content may not exceed 2000 characters"
				},
				close: {
					required: () => 'Please enter close',
					min: () => 'minimum 5 characters',
					max: () => "Close may not exceed 250 characters"
				}
			}
		};
		this.$validator.localize('en', dict);
        this.loadData();
    },
    methods: {
		sanitizeInput(event) {
			let sanitized = sanitizeInput(event);
            return sanitized;
        },
        sanitizeUrl(event) {
            return sanitizeUrl(event);
        },
        loadData: async function() {
			this.$route.meta.title = 'Reference - ' + this.changeTxt(this.$route.params.reference);
			this.title = this.$route.params.reference;
			const titleMap = {
				'filter-words': 'Filter Words',
				'protopia-owner': 'Protopia Owner',
				'wizard-content': 'Wizard Content',
				'coaching-templates': 'Coaching Templates'
			};
			this.title = titleMap[this.$route.params.reference] || this.$route.params.reference;
			await this.api.get(`configuration/${this.$route.params.reference}/${this.$route.params.editId}`).then(response => {
				if (response.data.results) {
					this.configurationObj = response.data.results
				} else {
					this.$router.go(-1);
				}
			});
        },
		changeTxt(value) {
			if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
		},
		updateData: async function() {
			this.$validator.validateAll().then(async result => {
				if (result) {
					await this.api
					.post(`configuration/${this.$route.params.reference}/update`, {dataObj: this.configurationObj})
					.then(async response => {
						if (response.data.status) {
							this.$router.go(-1);
						} else if (response.data.msg) {
							this.$toast.error(response.data.msg);
						} else {
							this.$toast.error(`Something went wrong, Please try again later`);
						}
					});
				}
			});
		},
		cancel: async function(reference) {
			this.$router.push(`/configuration/reference-${reference}`);
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfigurationEdit.vue